import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment-timezone';
import { BuyerApiService } from '../../../../shared/services/buyer-api/survey.service';
import { UserService } from '../../../../shared/services/user-service/user.service';
import { CommonService } from '../../../../shared/services/common-service/common-service';
import {
  SurveyGroup,
  PSIDList,
  BuyerSurveyResponse,
  PSIDCount,
  AdvanceFeasibilityCriterias,
  Locale,
} from '../../../../shared/interfaces/survey.interface';
import {
  BehaviorSubject,
  combineLatest,
  merge,
  Observable,
  of,
  Subscription,
} from 'rxjs';
import { SURVEY_STATUS } from '../../../../shared/constants/survey-status';
import { ZeroDashPipe } from '../../../shared/pipes/zero-dash-pipe';

//interface
import {
  CpiFeasibilityData,
  FeasibilityData,
  SurveyPayload,
} from '../../../../shared/interfaces/survey-meta-data.interface';
import {
  AdvanceFeasibilityCriteria,
  CriteriaQuota,
  FeasibilityExclusionData,
  FilterCriteria,
} from '../../../../shared/interfaces/feasibility.interface';
import {
  DateRange,
  DaterangepickerOption,
  FeasibilityQuota,
  FeasibilityQuotas,
  FeasibilityStatus,
  LocaleLanguageCountry,
} from '../../../shared/interfaces/feasibility.interface';
import { MultiCountryDraftData } from '../../../../shared/interfaces/create-surveys.interface';
import {
  QualificationPayload,
  RangeSet,
} from '../../../../shared/interfaces/qualification.interface';

//service
import { ToasterService } from '@purespectrum1/ui/toaster-service';
import { MultiCountryDraftService } from '../../../services/multi-country-draft/multi-country-draft.service';
import { FeasibilityDataService } from '../../../services/feasibility/feasibility-data.service';
import { SurveyMetaDataService } from '../../../../shared/services/survey-meta-data/survey-meta-data.service';
import { CreateSurveyService } from '../../../create-survey.service';

import { Constants } from '../header.constants';

import { notifyMessage } from '../../../../shared/constants/notify-message';

import {
  FILE_UPLOAD_LOCATION_QUOTAS,
  QUALIFICATION_CODES,
} from '../../../../shared/constants/qualification-code';
import {
  FeasibilityCriteria,
  FeasibilityTotal,
  QualificationFormatter,
  StringFormatter,
} from '../feasibility/feasibility.class';
import { SharedDataService } from '../../../../shared/services/shared-data-service/shared-data-service';
import { SelectDate } from '../../../../shared/interfaces/date';
import { LoaderService } from '@purespectrum1/ui/loader';
import { AuthService } from '../../../../shared/services/auth/auth.service';
import { SupportService } from '../../../services/support/support-service';
import { TemplateService } from '../../../../shared/services/template/template.service';
import { DaterangepickerComponent } from 'ng2-daterangepicker';
import { Audience, AudienceExtractor } from './domain/audience';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  share,
  skip,
  switchMap,
} from 'rxjs/operators';
import {
  ADVANCE_FEASIBILITY_CRITERIAS,
  CRITERIAS,
  FILTER_TYPE,
} from '../../../../shared/constants/advance-feasibility-constants';
import {
  TemplateInfo,
  TemplateListResponse,
} from '../../template-modal/template-modal.interface';
import {
  SelectedFile,
  TreeDropdownOption,
} from '../../../shared/interfaces/tree-dropdown-interface';
import { ProjectManagers } from '../../../../shared/interfaces/user.interface';
import { SectionToggleInfo } from '@purespectrum1/ui/accordion';
import { isEqual } from '../../../utils/deep-compare';
import { FeasibilityService } from '../../../services/feasibility/feasibility.service';

@Component({
  selector: 'ps-ui-advance-feasibility',
  templateUrl: './advance-feasibility.component.html',
  styleUrls: ['./advance-feasibility.component.css'],
  providers: [ZeroDashPipe],
})
export class AdvanceFeasibilityComponent implements OnInit, OnDestroy {
  @ViewChild('dateRangeFilterRef', { read: DaterangepickerComponent })
  private _dateRangeFilterRef: DaterangepickerComponent;

  readonly Constants = Constants;
  DEFAULT_INCOME_VALUES = this.Constants.DEFAULT_INCOME_VALUES;

  public feasibilityTypes: { name: string }[] = [
    {
      name: Constants.ADVANCE_FEASIBILITY.FEASIBILITY_TYPE.EXCLUDE,
    },
    {
      name: Constants.ADVANCE_FEASIBILITY.FEASIBILITY_TYPE.INCLUDE,
    },
  ];
  public selectFeasibilityType: { name: string } = {
    ...this.feasibilityTypes[0],
  }; // Default selection
  public surveyGroups: SurveyGroup[] = [];
  public psidRefList: string[] = [];
  public surveyGroupList: SurveyGroup[] = [];
  public dateRange: DateRange = {};
  public options: DaterangepickerOption;
  public showDropDown = false;
  public showLoaderForSelectLocation: boolean = false;
  public searchKeyword: string = '';
  public surveyId: number;
  public elementReferenceName?: string;
  feasibilityStatus: FeasibilityStatus = 'none';
  loading: boolean = false;
  totalFeasibility?: number = 0;
  multiCountrySelected: boolean = false;
  draftSaved: boolean = false;
  audienceDetails: Audience[] = [];
  psidCountObj = <PSIDCount>{};
  unutilizedQualificationsNames: string[] = [];
  feasibilityQuotaDetails: FeasibilityQuotas[] = [];
  allQuotas: FeasibilityQuotas[] = [];

  filterFeasibilityAudience = false;
  public isDisabledExclusionCheckBox: boolean = true;

  private _subscriptions: Subscription = new Subscription();
  filteredAudienceSection: boolean = false;
  private _qualifications: QualificationPayload[] = [];
  private _formatters: Map<number, QualificationFormatter> = new Map<
    number,
    QualificationFormatter
  >();

  public disableFeasibilityDropdown = true;
  // Criterias
  public filterType = FILTER_TYPE;
  public advanceFeasibilityCriterias: AdvanceFeasibilityCriteria[] =
    ADVANCE_FEASIBILITY_CRITERIAS;
  public selectedCriteria: AdvanceFeasibilityCriteria =
    {} as AdvanceFeasibilityCriteria;

  // Billing Number Filter
  public showBillingNumberDropDown = false;
  public billingNumberList: string[] = [];
  public selectedBillingNumbers: string[] = [];
  public selectedBillingIds: string[] = [];
  public billingNumberSearchKeyword: string = '';
  public showLoaderForBillingNumber: boolean = false;
  public billingNumberSurveys: SurveyGroup[] = [];
  public selectedTemplateIds: number[] = [];
  public selectedTemplateList: SelectedFile[] = [];
  public hasBillingSurveys: boolean = true;

  // Project Manager Filter
  public projectManagers: ProjectManagers[] = [];
  public selectedProjectManagers: ProjectManagers[];
  public templates: TemplateListResponse[];
  public templateOption: TreeDropdownOption = {
    uniqueKey: 'id',
    displayKey: 'name',
    navigationKey: 'templates',
    removeItem: false,
    icon: 'fa fa-file-text-o',
    noContentMsg: 'No Template created yet',
    mcIconIdentifier: 'is_mc_template',
  };
  public templateFolderOption: TreeDropdownOption = {
    uniqueKey: 'id',
    displayKey: 'name',
    navigationKey: 'subfolders',
    headerLabel: 'My Templates',
    removeItem: false,
    icon: 'fa fa-folder',
    noContentMsg: 'No Template created yet', // Even though it is template-folder content, this message is for ease of user
    mcIconIdentifier: 'is_mc_template',
  };
  public filters: FilterCriteria[] = [];
  public criteriaSurveys: SurveyGroup[] = [];
  public allSurveyGroups: SurveyGroup[] = [];
  public projectManagerIds: number[] = [];

  private _surveyGroupPsidRefList: string[] = [];
  private _includePsidRefList: string[] = [];
  private _isManualProcessing: boolean = false;
  private _currentCmp: number;
  private _locale: LocaleLanguageCountry = {
    languageCode: '',
    countryCode: '',
  };
  private _cpiFeasibilityDataWithoutExclusions: CpiFeasibilityData =
    this._surveyMetaDataService.defaultCpiFeasibilityData;
  private _cpiFeasibilityDataWithExclusions: CpiFeasibilityData =
    this._surveyMetaDataService.defaultCpiFeasibilityData;

  private _filterFeasibilityAudienceCommand$ = new BehaviorSubject<boolean>(
    false
  );
  private _criteriaSurveysCommand$ = new BehaviorSubject<SurveyGroup[]>([]);
  private _feasibilityTypeCommand$ = new BehaviorSubject<{ name: string }>(
    this.selectFeasibilityType
  );
  private _cpiFeasibilityDataWithExclusions$!: Observable<CpiFeasibilityData>;
  private _cpiFeasibilityDataWithoutExclusions$!: Observable<CpiFeasibilityData>;

  constructor(
    private _buyerApiService: BuyerApiService,
    private _commonService: CommonService,
    private _surveyMetaDataService: SurveyMetaDataService,
    private _createSurveyService: CreateSurveyService,
    private _multiCountryDraftService: MultiCountryDraftService,
    private _feasibilityDataService: FeasibilityDataService,
    private _feasibilityService: FeasibilityService,
    private _zeroDashPipe: ZeroDashPipe,
    private _toasterService: ToasterService,
    private _sharedDataService: SharedDataService,
    private _loading: LoaderService,
    private _auth: AuthService,
    private _supportService: SupportService,
    private _templateService: TemplateService,
    private _userService: UserService
  ) {}

  ngOnInit() {
    this.filteredAudienceSection =
      !!this._auth.buyerConfig?.enableAdvanceFeasibilityDropDown &&
      !!this._auth.buyerConfig?.includeToo;
    this.advanceFeasibilityCriterias[0].name = this.ProjectManagerLabel;
    this._createDateRangePickerOption();
    this._subscriptions.add(
      this._sharedDataService
        .getSurveyData()
        .pipe(filter((data) => Object.keys(data).length > 1))
        .subscribe((surveyResponse: BuyerSurveyResponse) => {
          this._onChangeLanguageCountryResetFilter(
            this._locale,
            surveyResponse.locale
          );
          this.surveyId = surveyResponse.ps_survey_id;
          const feasibilityType = {
            name: surveyResponse.incl_excl
              ? Constants.ADVANCE_FEASIBILITY.FEASIBILITY_TYPE.INCLUDE
              : Constants.ADVANCE_FEASIBILITY.FEASIBILITY_TYPE.EXCLUDE,
          };
          this._feasibilityTypeCommand$.next(feasibilityType);
          const {
            enable,
            start,
            end,
            criterias = [],
            criteriaSurveys = [],
          } = surveyResponse.feasibility_exclusions || {};
          if (start) {
            this.dateRange.start = this._momentApiCaller(moment, start)
              .tz(moment.tz.guess())
              .format('YYYY-MM-DD');
            this._dateRangeFilterRef?.datePicker.setStartDate(
              this._momentApiCaller(moment, start)
            );
          }
          if (end) {
            this.dateRange.end = this._momentApiCaller(moment, end)
              .tz(moment.tz.guess())
              .format('YYYY-MM-DD');
            this._dateRangeFilterRef?.datePicker.setEndDate(
              this._momentApiCaller(moment, end)
            );
          }
          this._manageExclusionCheckbox();
          this._filterFeasibilityAudienceCommand$.next(enable || false);
          this.surveyGroups = (surveyResponse.survey_grouping ?? [])
            .filter(
              (surveyId) => surveyId !== Number(surveyResponse.ps_survey_id)
            )
            .filter((surveyId) => !criteriaSurveys.includes(surveyId))
            .map((surveyId) => {
              return {
                id: surveyId,
                st: 0,
                tle: '',
                st_text: '',
              };
            });
          const filteredCriteriaSurveys = criteriaSurveys
            .filter(
              (surveyId) => surveyId !== Number(surveyResponse.ps_survey_id)
            )
            .map((surveyId) => {
              return {
                id: surveyId,
                st: 0,
                tle: '',
                st_text: '',
              };
            });
          this._criteriaSurveysCommand$.next(filteredCriteriaSurveys);
          this.getAllSurveyGroups();
          this._getPSIDData(this.allSurveyGroups);
          this._fetchProjectManagers(surveyResponse.buyer_company);
          this._mapFeasibilityCriterias(criterias);
          this._locale = {
            languageCode: surveyResponse.locale.language_code,
            countryCode: surveyResponse.locale.country_code,
          };
        })
    );

    this._subscriptions.add(
      this._createSurveyService.getMultiCountryData().subscribe((data) => {
        if (!data.qualifications?.length) {
          return;
        }
        this._qualifications = data.payloadQualifications;
        this.multiCountrySelected =
          data.selectedCountries && data.selectedCountries.length > 1;
        const incomeData = data.qualifications.find(
          (q) => q.qualification_code === QUALIFICATION_CODES.INCOME
        )?.data;
        if (incomeData?.length) {
          this.DEFAULT_INCOME_VALUES.prefix = incomeData[0].preFix;
        }
        this._formatters = this._makeQualFormatters();
      })
    );
    this._subscriptions.add(
      this._createSurveyService
        .getIsDraftSavedValue()
        .subscribe((val: boolean) => {
          this.draftSaved = val;
        })
    );
    this._subscriptions.add(
      this._multiCountryDraftService
        .getMultiCountryDraftData()
        .subscribe((data: MultiCountryDraftData) => {
          if (
            !this.draftSaved &&
            data &&
            data.countryData &&
            data.countryData.length
          ) {
            this.loading = true;
            this.totalFeasibility =
              this._feasibilityDataService.getTotalFeasbilityBeforeDraftSave(
                data
              );
            this.loading = false;
          }
        })
    );
    const getTemplateSubscription = this._templateService
      .getUpdatedTemplateList()
      .subscribe((templates) => {
        this.templates = templates;
      });
    this._subscriptions.add(getTemplateSubscription);
    const processingSubscriber = this._surveyMetaDataService
      .getSurveyProcessing()
      .subscribe(({ manual }) => {
        this._isManualProcessing = !!manual;
      });
    this._subscriptions.add(processingSubscriber);

    this._subscriptions.add(
      this._filterFeasibilityAudienceCommand$.subscribe((bool) => {
        this.filterFeasibilityAudience = bool;
      })
    );

    this._subscriptions.add(
      this._feasibilityTypeCommand$.subscribe((type) => {
        this.selectFeasibilityType = type;
      })
    );

    this._subscriptions.add(
      this._criteriaSurveysCommand$.subscribe((criteriaSurveys) => {
        this.criteriaSurveys = criteriaSurveys;
      })
    );

    // Manage Feasibility loading ellipsis
    this._manageFeasibilityLoader();
    this._subscriptions.add(
      this._sharedDataService.getLocaleData().subscribe((data: Locale) => {
        this._onChangeLanguageCountryResetFilter(this._locale, data);

        this._locale = {
          languageCode: data.language_code,
          countryCode: data.country_code,
        };
      })
    );

    this._fetchProjectManagers();

    // Create feasibility data steams
    this._initiateFeasibilityDataStreams();

    // Tracking feasibility request data change and then fetching new data
    this._fetchFeasibilityData();

    // Updating feasibility data locally as it is available
    this._locallyStoreFeasibilityData();

    // Whenever feasibility data changes or exclusion checkbox value, updating data in top bar
    this._updateFeasibilityDataInDropdownAndTopBar();
  }

  private _fetchProjectManagers(company?: number) {
    const cmp: number =
      company ||
      (this._auth.isLoggedInAsServiceBuyer()
        ? this._auth.serviceBuyer!.id
        : this._auth.user!.cmp);
    this._subscriptions.add(
      of(cmp)
        .pipe(
          filter(() => !!cmp && this._currentCmp !== cmp),
          switchMap(() => this._userService.getAllBuyerUser(cmp, false))
        )
        .subscribe(
          (projectManagers) => {
            this.projectManagers = projectManagers;
            this._currentCmp = cmp;
          },
          (error) => {
            this._showErrorMessage(error);
          }
        )
    );
  }

  private _createDateRangePickerOption() {
    this.options = {
      locale: Constants.ADVANCE_FEASIBILITY.DATE_PICKER.LOCALE,
      alwaysShowCalendars: false,
      showDropdowns: true,
      minYear: Constants.ADVANCE_FEASIBILITY.DATE_PICKER.MIN_YEAR,
      maxYear: Constants.ADVANCE_FEASIBILITY.DATE_PICKER.MAX_YEAR,
    };
  }

  private _initiateFeasibilityDataStreams(): void {
    this._cpiFeasibilityDataWithoutExclusions$ = this._surveyMetaDataService
      .getCpiFeasibilityData()
      .pipe(
        filter(
          (data) => !data.feasibilityData.loading && !data.cpiData.loading
        ),
        filter(
          (data) => !data.feasibilityData.request?.survey_grouping?.length
        ),
        map((data) => data),
        share()
      );

    this._cpiFeasibilityDataWithExclusions$ = this._surveyMetaDataService
      .getCpiFeasibilityData()
      .pipe(
        filter(
          (data) => !data.feasibilityData.loading && !data.cpiData.loading
        ),
        filter(
          (data) => !!data.feasibilityData.request?.survey_grouping?.length
        ),
        map((data) => data),
        share()
      );
  }

  private _fetchFeasibilityData(): void {
    const criteriaSurveyIdsChanage$ = this._criteriaSurveysCommand$.pipe(
      map((criteriaSurveys) => criteriaSurveys.map((c) => c.id)),
      distinctUntilChanged((x, y) => isEqual(x, y))
    );

    const feasibilityTypeChange$ = this._feasibilityTypeCommand$.pipe(
      map((type) => type),
      distinctUntilChanged((x, y) => isEqual(x, y))
    );

    const supplierDataChange$ = this._surveyMetaDataService
      .getSuppliersSelected()
      .pipe(distinctUntilChanged((x, y) => isEqual(x, y)));

    const surveyMetaDataChange$ = this._surveyMetaDataService
      .getFeasibilityRequestMetaData()
      .pipe(
        skip(1),
        map((data) => data),
        distinctUntilChanged((x, y) => isEqual(x, y))
      );

    const purePriceApplied$ = this._surveyMetaDataService.getPurePriceApplied();

    const feasibilityExclusionDataStream$ = combineLatest([
      criteriaSurveyIdsChanage$,
      feasibilityTypeChange$,
      surveyMetaDataChange$,
      supplierDataChange$,
      purePriceApplied$,
    ]).pipe(
      debounceTime(1000),
      map(([criteriaSurveyIds, feasibilityType, metaData]) => ({
        survey_id: Number(metaData.project_id),
        survey_grouping: criteriaSurveyIds,
        is_exclusion:
          feasibilityType.name ===
          Constants.ADVANCE_FEASIBILITY.FEASIBILITY_TYPE.EXCLUDE,
      })),
      share()
    );

    // Updating Feasibility data without exclusions
    this._subscriptions.add(
      feasibilityExclusionDataStream$.subscribe((feasibilityExclusionData) => {
        const { survey_id, is_exclusion = false } = feasibilityExclusionData;
        const emptyExclusionData = {
          survey_id,
          survey_grouping: [],
          is_exclusion,
        };
        this._surveyMetaDataService.sendFeasibilityExclusionData(
          emptyExclusionData
        );
      })
    );

    // Updating feasibility data with exclusions
    this._subscriptions.add(
      feasibilityExclusionDataStream$
        .pipe(
          filter(
            (feasibilityExclusionData) =>
              !!feasibilityExclusionData.survey_grouping.length
          )
        )
        .subscribe((feasibilityExclusionData) => {
          const { survey_grouping, is_exclusion, survey_id } =
            feasibilityExclusionData;
          const exclusionData: FeasibilityExclusionData = {
            survey_id,
            survey_grouping,
            is_exclusion,
          };
          this._surveyMetaDataService.sendFeasibilityExclusionData(
            exclusionData
          );
        })
    );
  }

  private _locallyStoreFeasibilityData(): void {
    this._subscriptions.add(
      this._cpiFeasibilityDataWithExclusions$.subscribe((data) => {
        this._cpiFeasibilityDataWithExclusions = data;
      })
    );

    this._subscriptions.add(
      this._cpiFeasibilityDataWithoutExclusions$.subscribe((data) => {
        this._cpiFeasibilityDataWithoutExclusions = data;
        if (!this.criteriaSurveys.length) {
          this._cpiFeasibilityDataWithExclusions = data;
        }
      })
    );
  }

  private _updateFeasibilityDataInDropdownAndTopBar(): void {
    const cpiFeasibilityDataUpdate$ = merge(
      this._cpiFeasibilityDataWithExclusions$,
      this._cpiFeasibilityDataWithoutExclusions$
    );

    this._subscriptions.add(
      combineLatest([
        this._filterFeasibilityAudienceCommand$,
        cpiFeasibilityDataUpdate$,
      ])
        .pipe(
          map(([filterFeasibilityAudience]) => {
            if (filterFeasibilityAudience) {
              return this._cpiFeasibilityDataWithExclusions;
            }
            return this._cpiFeasibilityDataWithoutExclusions;
          })
        )
        .subscribe(
          ({ feasibilityData, cpiData, supplierSpecificInfo, mcData }) => {
            this._mapFeasibilityDetails(feasibilityData);
            this._surveyMetaDataService.sendCPIData(cpiData);
            this._surveyMetaDataService.sendFeasibilityData(feasibilityData);
            this._surveyMetaDataService.sendSupplierSpecificInfo(
              supplierSpecificInfo
            );

            if (mcData) {
              this._multiCountryDraftService.setMultiCountryFeasCpiData(mcData);
            }
          }
        )
    );
  }

  private _manageFeasibilityLoader(): void {
    this._subscriptions.add(
      this._surveyMetaDataService
        .getFeasibilityData()
        .subscribe(({ loading }) => {
          this.loading = !!loading;

          if (this.loading) {
            this.feasibilityStatus = 'warning';
          }
        })
    );
  }

  public onFeasibilityTypeChange(selectedItem: any) {
    if (this.selectFeasibilityType.name !== selectedItem.name) {
      if (selectedItem.name === 'Exclude' && this.surveyId) {
        this._buyerApiService.clearUploadedPSIDs(this.surveyId).toPromise();
        this.psidRefList = [];
      }
      this.surveyGroups = [];
      this.resetFilteredAudience();
      this._feasibilityTypeCommand$.next(selectedItem);
    }
  }

  private _resetDataOnFeasibilityTypeChange() {
    this.resetDateRange();
    this._resetFilterFeasibilityAudience();
    this._getCriteriaSurveys();
  }

  public selectedDate(value: SelectDate) {
    this.dateRange.start = new Date(value.start._d);
    this.dateRange.end = new Date(value.end._d);
    this._getCriteriaSurveys();
    this._manageExclusionCheckbox();
  }

  private _getPSIDList(surveyIds: number[] = []) {
    const { start, end } = this._getStartEndDate();
    this._loading.loading = true;
    this._buyerApiService
      .getPSIDList(start as string, end as string, surveyIds)
      .subscribe(
        (response) => {
          this._mapSurveyGroupingAndRefList(response);
          this._loading.loading = false;
        },
        (err) => {
          this._prepareAndShowError(err, 'Error while fetching PSIDs.');
          this._loading.loading = false;
        }
      );
  }

  private _prepareAndShowError(err: any, defaultErrorMsg = '') {
    const { error: { ps_api_response_message = defaultErrorMsg } = {} } = err;
    this._toasterService.error(ps_api_response_message);
  }

  private _getPSIDCounts() {
    this.getAllSurveyGroups();
    const surveyIds = this._mapSurveyIds(this.allSurveyGroups);
    if (!surveyIds.length) {
      this.psidCountObj.total_count = 0;
      return;
    }
    this._loading.loading = true;
    this._PSIDCount(surveyIds).subscribe((res) => {
      this._loading.loading = false;
      this.psidCountObj = res;
    });
  }

  private _isExclusion(): boolean {
    return (
      this.selectFeasibilityType.name ===
      this.Constants.ADVANCE_FEASIBILITY.FEASIBILITY_TYPE.EXCLUDE
    );
  }

  private _PSIDCount(surveyIds: number[]) {
    const isExclusion = this._isExclusion();
    return this._buyerApiService.getPSIDCounts(isExclusion, surveyIds).pipe(
      catchError((err) => {
        this._prepareAndShowError(err, 'Error while fetching PSID counts.');
        this._loading.loading = false;
        return of({ total_count: 0 });
      })
    );
  }

  private _mapSurveyGroupingAndRefList(psidResponse: PSIDList) {
    const { survey_ids = [], ref_list = [] } = psidResponse;
    this.surveyGroups = survey_ids.map((id) => {
      return { id, st: 0, tle: '', st_text: '' };
    });
    this._surveyGroupPsidRefList = ref_list;
    this._getPsidRefList();
    if (this.psidRefList.length === Constants.MAGIC_NUMBERS.ZERO) {
      this._toasterService.error(notifyMessage.errorMessage.NO_PSIDS_FOUND);
    }
    this._getPSIDCounts(); // For Include
  }

  private _getStartEndDate() {
    let { start = '', end = '' } = this.dateRange;
    if (start && end) {
      start = this._commonService.formatDate(start as Date);
      end = this._commonService.formatDate(end as Date);
    }
    return { start, end };
  }

  private _mapSurveyIds(surveyGroups: SurveyGroup[]) {
    return surveyGroups.map((survey) => Number(survey.id));
  }

  public resetDateRange() {
    this.dateRange = {};
    const currentDate = this._momentApiCaller(moment, Date.now()).tz(
      moment.tz.guess()
    );
    this._dateRangeFilterRef?.datePicker.setStartDate(currentDate);
    this._dateRangeFilterRef?.datePicker.setEndDate(currentDate);
    this._manageExclusionCheckbox();
  }

  public cancelDateRange() {
    this._resetDataOnFeasibilityTypeChange();
    this._manageExclusionCheckbox();
  }

  public getGroupSurveyIds(
    startDate: string,
    endDate: string,
    status: string = '',
    searchValue: string = '',
    searchKey: string = 'id'
  ) {
    const incl_excl = this._getIncludeExcludeValues();
    this._buyerApiService
      .getGroupSurveys(
        startDate,
        endDate,
        this._locale,
        status,
        searchKey,
        searchValue,
        incl_excl
      )
      .subscribe(
        (response) => {
          this.surveyGroups = response;
          this._resetFilterFeasibilityAudience();
          this._getPSIDCounts();
        },
        (err: any) => {
          this._showErrorMessage(err);
        }
      );
  }

  private _getIncludeExcludeValues() {
    return !this._isExclusion() ? '1' : '0';
  }

  public removeSurveyObject(item: SurveyGroup) {
    this.surveyGroups = this.surveyGroups.filter(
      (surveyGroup: SurveyGroup) => surveyGroup.id !== item.id
    );
    this._removeSurveyFromCriteria(item);
    this._resetFilterFeasibilityAudience();
    this.getAllSurveyGroups();
    this._getPSIDData(this.allSurveyGroups);
    if (!this.allSurveyGroups.length) {
      this.resetDateRange();
    }
    if (!this._isExclusion()) {
      this._getIncludeCriteriaSurveys(this.criteriaSurveys);
    }
  }

  openDropDown(show: boolean = true) {
    this.showDropDown = show;
  }

  onSearchKeyUp(searchTextValue: string) {
    if (searchTextValue.length > 2) {
      this._searchSurveyGroupList(searchTextValue);
    } else {
      this.surveyGroupList = [];
    }
  }
  private _searchSurveyGroupList(
    searchTextValue: string,
    searchKey: string = 'id'
  ) {
    this.showLoaderForSelectLocation = true;
    this.searchKeyword = searchTextValue;
    const start = '';
    const end = '';
    const status = [SURVEY_STATUS.INVOICE, SURVEY_STATUS.CLOSED].toString();
    const inclExcl = this._getIncludeExcludeValues();
    this._buyerApiService
      .getGroupSurveys(
        String(start),
        String(end),
        this._locale,
        status,
        searchKey,
        searchTextValue,
        inclExcl
      )
      .subscribe(
        (response) => {
          this.surveyGroupList = response;
          this._filterSurveyGroupList();
          this.showLoaderForSelectLocation = false;
        },
        (err: any) => {
          this._showErrorMessage(err);
        }
      );
  }

  public selectSurvey(survey: SurveyGroup) {
    const surveyIndex = this.surveyGroups.findIndex(
      (surveyGroup) => surveyGroup.id === survey.id
    );
    if (surveyIndex === -1) {
      this.surveyGroups.push(survey);
      this.getAllSurveyGroups();
      this._getPSIDData(this.allSurveyGroups);
    }
  }

  private _getPSIDData(surveyGroups: SurveyGroup[]) {
    const surveyIds = this._mapSurveyIds(surveyGroups);
    if (!this._isExclusion()) {
      if (surveyIds.length) {
        this._getPSIDList(surveyIds);
      } else {
        this._surveyGroupPsidRefList = [];
        this.psidCountObj.total_count = 0;
      }
    } else {
      this._getPSIDCounts();
    }
    if (this.surveyGroupList.length) {
      this._filterSurveyGroupList();
    }
  }

  private _showErrorMessage(err: any) {
    if (err.error.apiStatus === 'failure') {
      this._toasterService.error(err.error.msg);
    }
  }

  get feasibilityQuota(): FeasibilityQuotas[] {
    return this.feasibilityQuotaDetails;
  }

  get parsedFeasibilityQuota() {
    const feasibilityQuota = this.feasibilityQuota;
    const result = feasibilityQuota.map((item) => {
      const isUnknown = item.quotas.every(
        (quota) => quota.feasibiltyValue === 'UNKN'
      );
      if (isUnknown) {
        item.quotas = [];
      }
      return item;
    });
    return result;
  }

  set feasibilityQuota(value: FeasibilityQuotas[]) {
    this.feasibilityQuotaDetails = value;
    this.setFeasibilityStats();
  }

  private _resetFilterFeasibilityAudience() {
    this._filterFeasibilityAudienceCommand$.next(false);
  }

  public onFilterFeasibilityAudience(value: boolean): void {
    this._filterFeasibilityAudienceCommand$.next(value);
  }

  private _mapFeasibilityDetails({
    defaultQuota,
    quotaSet,
    response,
    request,
    hasQuota = false,
    loading,
  }: FeasibilityData) {
    this.setFeasibilityStats();
    if (loading && this._isManualProcessing) {
      return;
    }
    if (!quotaSet || !response || loading) {
      this.feasibilityQuotaDetails = [];
      this.disableFeasibilityDropdown = true;
      return;
    }
    this.loading = false;
    this.totalFeasibility = response.total_feasibility;
    this.feasibilityQuota = [];

    const { prefix: currency } = this.DEFAULT_INCOME_VALUES;
    this.audienceDetails = new AudienceExtractor(
      defaultQuota ?? [],
      quotaSet,
      currency
    ).extract();

    const mappedFeasibilityQuotas: FeasibilityQuotas[] = [];
    const feasTotal = new FeasibilityTotal(response, quotaSet);
    const feasCriteria = new FeasibilityCriteria(response, hasQuota);
    const unutilizedQualificationsNames: { name: string; code: number }[] = [];
    quotaSet.forEach((criteriaQuotas, qualificationCode: number) => {
      const qualificationFormatter = this._formatters.get(qualificationCode)!;
      const isNestedQuotas = this._isNestedQuotas(criteriaQuotas);
      const name = !isNestedQuotas
        ? qualificationFormatter?.name
        : 'Autonested';
      const quota: FeasibilityQuotas = {
        qualificationCode,
        name,
        quotas: [], // show `Population Data is Unavailable` message if genpop settings is not available in DB
        showQualificationMessage:
          feasCriteria.unusedQualifications.includes(qualificationCode),
      };
      mappedFeasibilityQuotas.push(quota);
      let quotaCategoryFeasibility = 0;
      criteriaQuotas.forEach((q) => {
        const count = feasTotal.count(q.buyer_quota_id);
        quotaCategoryFeasibility += count;
        let feasible = count >= q.required_count;
        const isUnusedCriteria =
          feasCriteria.unusedQualifications.includes(qualificationCode) ||
          feasCriteria.checkUnusedCriteria(qualificationCode, q);
        if (isUnusedCriteria) {
          feasible = false; // `false` to show UNKN and red highlight class
          // we should show warning only once and not everytime feasibility is loaded.
          if (
            !this.unutilizedQualificationsNames.includes(name.toUpperCase()) &&
            !isNestedQuotas
          ) {
            unutilizedQualificationsNames.push({
              name: name.toUpperCase(),
              code: qualificationCode,
            });
          }
        }
        const feasibiltyValue = isUnusedCriteria
          ? 'UNKN'
          : this._zeroDashPipe.transform(count, '1.0-2');
        const desiredFeasibilty = this._zeroDashPipe.transform(
          q.required_count,
          '1.0-2'
        );

        let feasibiltyDifference: string | null = '-';

        if (
          feasibiltyValue &&
          feasibiltyValue !== 'UNKN' &&
          desiredFeasibilty
        ) {
          const feasDifference = count - q.required_count;
          feasibiltyDifference = this._zeroDashPipe.transform(
            feasDifference,
            '1.0-2'
          );
        }

        const criteriaLabel = this._getCriteriaLabels(q);
        let quotas: FeasibilityQuota = {
          range: criteriaLabel,
          feasible,
          feasibiltyValue,
          desiredFeasibilty,
          feasibiltyDifference,
        };
        feasCriteria.checkForUnusedQualificationsWithoutQuota(
          unutilizedQualificationsNames,
          q.criteria,
          this.unutilizedQualificationsNames
        );
        quota.quotas.push(quotas);
      });
    });
    // pushing into scope so that we do not show the warning message again on feasibility load.
    if (unutilizedQualificationsNames.length) {
      const names = unutilizedQualificationsNames.map(
        (qualification) => qualification.name
      );
      const codes = unutilizedQualificationsNames.map(
        (qualification) => qualification.code
      );

      const criterias = [...new Set(names)].join(', ');
      const qualificationCodes = [...new Set(codes)].join(', ');
      this._toasterService.warning(
        notifyMessage.warningMessage.FEASIBILITY.UNUSED_CRITERIA.replace(
          '<QUALIFICATIONS_NAME>',
          criterias
        )
      );

      this._supportService
        .notifyNoFeasibility(
          request?.project_id,
          this._auth.user?.eml,
          criterias,
          qualificationCodes,
          request?.survey_localization
        )
        .subscribe();

      // pushing into scope so that we do not show the warning message again on feasibility load.
      this.unutilizedQualificationsNames.push(...names);
    }
    this.totalFeasibility = feasTotal.calculate();

    this.allQuotas = mappedFeasibilityQuotas; // in this default quota is also included
    this.feasibilityQuota = hasQuota ? mappedFeasibilityQuotas : [];
    this.disableFeasibilityDropdown = false;
  }

  private _isNestedQuotas(criteriaQuotas: CriteriaQuota[]) {
    return criteriaQuotas.some(
      (quota) => quota.quota_category === 'autoNested'
    );
  }

  private _getCriteriaLabels(
    quota: CriteriaQuota & { isNested?: boolean }
  ): string {
    let criteriaLabel: string[] = [];
    for (const criteria of quota.criteria) {
      if (criteria.condition_codes) {
        const condition = this._filterConditionLabels(
          criteria.qualification_code,
          criteria.condition_codes,
          criteria.group_name
        );
        criteriaLabel = criteriaLabel.concat(condition);
      }
      if (criteria.range_sets) {
        const condition = this._getRangeLabels(
          criteria.qualification_code,
          criteria.range_sets
        );
        criteriaLabel = criteriaLabel.concat(condition);
      }
    }
    return this._buildFinalLabel(criteriaLabel);
  }

  setFeasibilityStats() {
    if (!this.allQuotas.length) {
      this.feasibilityStatus = 'none';
      return;
    }
    const isNotFeasible = this.allQuotas.some((f) =>
      f.quotas.some((q) => !q.feasible)
    );
    this.feasibilityStatus = isNotFeasible ? 'danger' : 'success';
  }

  private _buildFinalLabel(criteriaLabel: Array<string>): string {
    let label = criteriaLabel.filter(Boolean).toString();
    if (label.length > Constants.SUBSTRING_VALUE) {
      label = label.substring(0, Constants.SUBSTRING_VALUE).concat('...');
    }
    return label;
  }

  private _makeQualFormatters() {
    const qualFormatters = new Map<number, QualificationFormatter>();
    const { prefix: currencySymbol } = this.DEFAULT_INCOME_VALUES;
    qualFormatters.set(
      QUALIFICATION_CODES.INCOME,
      new QualificationFormatter(
        QUALIFICATION_CODES.INCOME,
        'Income',
        new StringFormatter(currencySymbol, ` - ${currencySymbol}`)
      )
    );
    qualFormatters.set(
      QUALIFICATION_CODES.AGE,
      new QualificationFormatter(
        QUALIFICATION_CODES.AGE,
        'Age',
        new StringFormatter(undefined, ' yr - ', ' yr')
      )
    );
    this._qualifications.forEach((qual) => {
      const code: number = qual.qualification_code;
      const name: string = qual.qualification_name;
      const haveQualification = qualFormatters.has(code);
      if (!haveQualification) {
        qualFormatters.set(
          code,
          new QualificationFormatter(
            code,
            `${name[0]}${name.toLowerCase().substring(1)}`,
            new StringFormatter()
          )
        );
      }
    });
    return qualFormatters;
  }

  private _filterConditionLabels(
    qualificationCode: number,
    codes: string[],
    groupName?: string
  ) {
    if (FILE_UPLOAD_LOCATION_QUOTAS.includes(qualificationCode)) {
      return groupName ? groupName : '';
    }
    return this._getConditionLabels(qualificationCode, codes);
  }

  private _getRangeLabels(qualificationCode: number, rangeSet: RangeSet[]) {
    let rangeLabels: string[] = [];
    const qualificationFormatter = this._formatters.get(qualificationCode)!;
    if (qualificationFormatter) {
      rangeSet.forEach((range) => {
        rangeLabels.push(qualificationFormatter.formatRange(range));
      });
    }
    return rangeLabels.join(',');
  }

  private _getConditionLabels(qualificationCode: number, codes: string[]) {
    let condNames: string[] = [];
    codes.forEach((code) => {
      this._qualifications
        .find((qual) => qual.qualification_code === qualificationCode)
        ?.condition_names?.filter((names) =>
          Object.keys(names).includes(code.toString())
        )
        .map((codeNames) =>
          condNames.push((codeNames as any)[code.toString()])
        );
    });

    return condNames.length > 1
      ? condNames.join(',').substring(0, 20).concat('...')
      : condNames[0];
  }

  avoidClose(e: Event) {
    e.stopPropagation();
  }

  closeDropdown(close: boolean) {
    if (close && this.filteredAudienceSection) {
      const { start, end } = this._getStartEndDate();
      const updatePayload = {
        incl_excl: Number(this._getIncludeExcludeValues()),
        ref_list: this.psidRefList.map((psid) => {
          return { psid };
        }),
        survey_grouping: this._mapSurveyIds(this.allSurveyGroups),
        feasibility_exclusions: {
          enable: this.filterFeasibilityAudience,
          start,
          end,
          criterias: this._getSelectedCriterias(),
          criteriaSurveys: this.criteriaSurveys.map((survey) => survey.id),
        },
      } as SurveyPayload;
      this._surveyMetaDataService.sendSurveyPayload(updatePayload);
    }
  }

  private _getSelectedCriterias() {
    const criterias: AdvanceFeasibilityCriterias[] = [];

    // Project Manager
    if (this.selectedProjectManagers?.length) {
      criterias.push({
        id: CRITERIAS.PROJECT_MANAGER.id,
        name: CRITERIAS.PROJECT_MANAGER.name,
        values: this.selectedProjectManagers.map((projectManagers) => ({
          id: projectManagers.id,
          name: projectManagers.name,
        })),
      });
    }

    // Template
    if (this.selectedTemplateList?.length) {
      criterias.push({
        id: CRITERIAS.TEMPLATE.id,
        name: CRITERIAS.TEMPLATE.name,
        values: this.selectedTemplateList,
      });
    }

    // Billing Number
    if (this.selectedBillingNumbers?.length) {
      criterias.push({
        id: CRITERIAS.BILLING_NUMBER.id,
        name: CRITERIAS.BILLING_NUMBER.name,
        values: this.selectedBillingNumbers.map(
          (billingNumber) =>
            ({
              name: billingNumber,
            } as AdvanceFeasibilityCriteria)
        ),
      });
    }

    return criterias;
  }

  private _mapFeasibilityCriterias(criterias: AdvanceFeasibilityCriterias[]) {
    criterias.forEach((criteria) => {
      // Project Manager
      if (criteria.id === CRITERIAS.PROJECT_MANAGER.id) {
        this.onProjectManagerChange(criteria.values as ProjectManagers[]);
        this.projectManagerIds = criteria.values.map(
          (projectManager) => projectManager.id
        );
      }

      // Template
      if (criteria.id === CRITERIAS.TEMPLATE.id) {
        this.selectedTemplateList = criteria.values;
        this.selectedTemplateIds = criteria.values.map(
          (template) => template.id
        );
        this._checkTemplatesById(
          this.templates,
          this.selectedTemplateIds,
          true
        );
      }

      // Billing Number
      if (criteria.id === CRITERIAS.BILLING_NUMBER.id) {
        this.selectedBillingNumbers = criteria.values.map(
          (billingNumbers) => billingNumbers.name
        );
        this.selectedBillingIds = [...this.selectedBillingNumbers];
      }

      this.filters.push({
        selectedLists: criteria.values.map((item) => item.name),
        criteria: criteria.name,
      });
    });
  }

  private _checkTemplatesById(
    templates: TemplateListResponse[],
    templateIds: number[],
    ischecked: boolean
  ) {
    templates?.forEach((template) => {
      if (template.templates) {
        template.templates.forEach(
          (temp: TemplateInfo & { isChecked?: boolean }) => {
            if (temp.id && templateIds.includes(temp.id)) {
              temp.isChecked = ischecked;
            }
          }
        );
      }
      if (template.subfolders && template.subfolders.length) {
        return this._checkTemplatesById(
          template.subfolders,
          templateIds,
          ischecked
        );
      }
    });
  }

  private _filterSurveyGroupList() {
    this.surveyGroupList = this.surveyGroupList.filter(
      ({ id }) =>
        !this.surveyGroups.some((surveyGroup) => surveyGroup.id === id)
    );
  }

  private _momentApiCaller(momentLib: any, ...props: unknown[]) {
    return 'default' in momentLib
      ? momentLib.default(...props)
      : momentLib(...props);
  }
  private _manageExclusionCheckbox() {
    this.isDisabledExclusionCheckBox = true;

    if (this.allSurveyGroups.length) {
      this.isDisabledExclusionCheckBox = false;
    }
  }

  public onCriteriaChange(selectedItem: AdvanceFeasibilityCriteria) {
    if (this.selectedCriteria.name !== selectedItem.name) {
      this.selectedCriteria = selectedItem;
      // this._resetSelection();
    }
  }

  private _resetSelection() {
    this.selectedProjectManagers = [];
    this.selectedTemplateList = [];
    this.showBillingNumberDropDown = false;
    this.billingNumberSearchKeyword = '';
    this.billingNumberList = [];
    this.selectedBillingNumbers = [];
    this._resetTemplates(this.templates, false);
  }

  private _resetTemplates(
    templates: TemplateListResponse[],
    ischecked: boolean
  ) {
    templates?.forEach((template) => {
      if (template.templates) {
        template.templates.forEach(
          (temp: TemplateInfo & { isChecked?: boolean }) =>
            (temp.isChecked = ischecked)
        );
      }
      if (template.subfolders?.length) {
        return this._resetTemplates(template.subfolders, ischecked);
      }
    });
  }

  public onProjectManagerChange(selectedProjectManagers: ProjectManagers[]) {
    this.selectedProjectManagers = selectedProjectManagers;
  }

  onBillingNumberSearchKeyUp(searchTextValue: string) {
    if (searchTextValue.length > 2) {
      this.showBillingNumberDropDown = true;
      this._searchBillingNumber(searchTextValue);
    } else {
      this.billingNumberList = [...this.selectedBillingNumbers];
      this.showBillingNumberDropDown = false;
    }
  }

  private _searchBillingNumber(searchTextValue: string) {
    this.showLoaderForBillingNumber = true;
    this.billingNumberSearchKeyword = searchTextValue;
    const { start, end } = this._getStartEndDate();
    const status = [SURVEY_STATUS.INVOICE, SURVEY_STATUS.CLOSED].toString();
    const incl_excl = this._getIncludeExcludeValues();
    this._buyerApiService
      .getSurveysLookup(
        String(start),
        String(end),
        this._locale,
        status,
        'survey_po',
        searchTextValue,
        incl_excl
      )
      .subscribe(
        (response) => {
          this.billingNumberSurveys = response;
          this.billingNumberList = [
            ...new Set(response.map((res) => res.billing_id || '')),
          ];
          this.showLoaderForBillingNumber = false;
          this.hasBillingSurveys = !!this.billingNumberList.length;
        },
        (err: any) => {
          this._showErrorMessage(err);
        }
      );
  }

  selectBillingNumber(billingNumber: string) {
    const selectedBillingNumberIndex =
      this.findSelectedBillingNumberIndex(billingNumber);
    if (selectedBillingNumberIndex > -1) {
      this.selectedBillingNumbers = [
        ...this.selectedBillingNumbers.slice(0, selectedBillingNumberIndex),
        ...this.selectedBillingNumbers.slice(selectedBillingNumberIndex + 1),
      ];
    } else {
      this.selectedBillingNumbers = [
        ...this.selectedBillingNumbers,
        billingNumber,
      ];
    }
  }

  findSelectedBillingNumberIndex(billingNumber: string): number {
    return this.selectedBillingNumbers.findIndex(
      (text: string) => text === billingNumber
    );
  }

  onSubmitProjectManager() {
    if (this.selectedProjectManagers?.length) {
      this._addFilters(this.selectedProjectManagers.map((item) => item.name));
      this.projectManagerIds = this.selectedProjectManagers.map(
        (projectManager) => projectManager.id
      );
      this._getCriteriaSurveys();
    }
  }

  onSubmitBillingNumber() {
    this.showBillingNumberDropDown = false;
    this.billingNumberSearchKeyword = '';
    if (this.selectedBillingNumbers?.length) {
      this._addFilters(this.selectedBillingNumbers);
      this.selectedBillingIds = [...this.selectedBillingNumbers];
      this._getCriteriaSurveys();
    }
  }

  private _addFilters(filters: string[]) {
    const filterIndex = this.filters.findIndex(
      (filterItem: FilterCriteria) =>
        filterItem.criteria === this.selectedCriteria.name
    );
    if (filterIndex > -1) {
      this.filters[filterIndex].selectedLists = filters;
    } else {
      this.filters.push({
        selectedLists: filters,
        criteria: this.selectedCriteria.name,
      });
    }
  }

  removeFilter(filterElement: string, criteria: string) {
    const filterIndex = this.filters.findIndex(
      (filterItem: FilterCriteria) => filterItem.criteria === criteria
    );
    this.filters[filterIndex].selectedLists = this.filters[
      filterIndex
    ].selectedLists.filter((item: string) => item !== filterElement);
    this.filters = this.filters.filter(
      (filterItem) => filterItem.selectedLists.length
    );
    if (criteria === CRITERIAS.BILLING_NUMBER.name) {
      this._filterBillingNumbers(filterElement);
    }
    if (criteria === CRITERIAS.TEMPLATE.name) {
      this._filterTemplates(filterElement);
    }
    if (criteria === CRITERIAS.PROJECT_MANAGER.name) {
      this._filterProjectManagers(filterElement);
    }
  }

  public getAllSurveyGroups() {
    let set = new Set();
    this.allSurveyGroups = [
      ...this.surveyGroups,
      ...this.criteriaSurveys,
    ].filter((item) => {
      if (!set.has(item.id)) {
        set.add(item.id);
        return true;
      }
      return false;
    }, set);
    if (
      this.selectFeasibilityType.name ===
      Constants.ADVANCE_FEASIBILITY.FEASIBILITY_TYPE.EXCLUDE
    ) {
      this._manageExclusionCheckbox();
    }
  }

  private _removeSurveyFromCriteria(item: SurveyGroup) {
    const filteredCriteriaSurveys = this.criteriaSurveys.filter(
      (criteriaSurvey: SurveyGroup) => criteriaSurvey.id !== item.id
    );
    this._criteriaSurveysCommand$.next(filteredCriteriaSurveys);
    this._getPSIDCounts();
  }

  selectedTemplates(selectedTemplates: SelectedFile[]) {
    this.selectedTemplateList = selectedTemplates;
    this._addFilters(selectedTemplates.map((template) => template.name));
    this.selectedTemplateIds = selectedTemplates.map((template) => template.id);
    this._getCriteriaSurveys();
  }

  private _getCriteriaSurveys() {
    if (this._validateEmptyCriteria()) {
      this._criteriaSurveysCommand$.next([]);
      this._getPSIDCounts();
      return;
    }
    const { start, end } = this._getStartEndDate();
    const status = [SURVEY_STATUS.INVOICE, SURVEY_STATUS.CLOSED].toString();
    const incl_excl = this._getIncludeExcludeValues();
    this._buyerApiService
      .getSurveysLookup(
        String(start),
        String(end),
        this._locale,
        status,
        '',
        '',
        incl_excl,
        this.selectedBillingIds,
        this.selectedTemplateIds,
        this.projectManagerIds
      )
      .subscribe(
        (response) => {
          if (!this._isExclusion()) {
            this._getIncludeCriteriaSurveys(response);
          } else {
            this._criteriaSurveysCommand$.next(response);
            this._getPSIDCounts();
          }
        },
        (err: any) => {
          this._showErrorMessage(err);
        }
      );
  }

  private _filterSelectedTemplateList(filterElement: string) {
    this.selectedTemplateList = this.selectedTemplateList.filter(
      (template) => template.name !== filterElement
    );
  }

  private _filterSelectedProjectManagers(filterElement: string) {
    this.selectedProjectManagers = this.selectedProjectManagers.filter(
      (projectManager) => projectManager.name !== filterElement
    );
  }

  private _filterBillingNumbers(filterElement: string) {
    this.selectedBillingNumbers = this.selectedBillingNumbers.filter(
      (billingNumber) => billingNumber !== filterElement
    );
    this.selectedBillingIds = [...this.selectedBillingNumbers];
    this._getCriteriaSurveys();
  }

  private _filterTemplates(filterElement: string) {
    this._filterSelectedTemplateList(filterElement);
    this.selectedTemplateIds = this.selectedTemplateList.map(
      (template) => template.id
    );
    this._getCriteriaSurveys();
  }

  private _filterProjectManagers(filterElement: string) {
    this._filterSelectedProjectManagers(filterElement);
    this.projectManagerIds = this.selectedProjectManagers.map(
      (projectManager) => projectManager.id
    );
    this._getCriteriaSurveys();
  }

  private _mapincludeSurveyGroupingAndRefList(psidResponse: PSIDList) {
    const { survey_ids = [], ref_list = [] } = psidResponse;
    const criteriaSurveys = survey_ids.map((id) => {
      return { id, st: 0, tle: '', st_text: '' };
    });
    this._criteriaSurveysCommand$.next(criteriaSurveys);
    this._includePsidRefList = ref_list;
    this._getPsidRefList();
    if (this.psidRefList.length === Constants.MAGIC_NUMBERS.ZERO) {
      this._toasterService.error(notifyMessage.errorMessage.NO_PSIDS_FOUND);
    }
  }

  private _getIncludeCriteriaSurveys(response: SurveyGroup[]) {
    const { start, end } = this._getStartEndDate();
    const surveyIds = response.map((res) => res.id);
    if (!surveyIds.length) {
      this._criteriaSurveysCommand$.next([]);
      this._includePsidRefList = [];
      this._getPsidRefList();
      return;
    }
    this._loading.loading = true;
    this._buyerApiService
      .getPSIDList(start as string, end as string, surveyIds)
      .subscribe(
        (psIdResponse) => {
          this._mapincludeSurveyGroupingAndRefList(psIdResponse);
          this._getPSIDCounts();
          this._loading.loading = false;
        },
        (err) => {
          this._prepareAndShowError(err, 'Error while fetching PSIDs.');
          this._loading.loading = false;
        }
      );
  }

  private _validateEmptyCriteria() {
    const { start, end } = this._getStartEndDate();
    return (
      !this.selectedTemplateIds.length &&
      !this.projectManagerIds.length &&
      !this.selectedBillingIds.length &&
      !start &&
      !end
    );
  }

  private _getPsidRefList() {
    this.psidRefList = [
      ...new Set([
        ...this._surveyGroupPsidRefList,
        ...this._includePsidRefList,
      ]),
    ];
  }
  public resetFilteredAudience() {
    this.filters = [];
    this.surveyGroups = [];
    this.selectedTemplateIds = [];
    this.selectedBillingIds = [];
    this.projectManagerIds = [];
    this._resetSelection();
    this._resetDataOnFeasibilityTypeChange();
    this._getCriteriaSurveys();
    this.selectFeasibilityType = {
      ...this.feasibilityTypes[0],
    };
    this.searchKeyword = '';
    this.surveyGroupList = [];
    this.showDropDown = false;
    this.selectedCriteria = {} as AdvanceFeasibilityCriteria;
  }

  toggleAccordion(event: SectionToggleInfo) {
    if (event.opened) {
      this.elementReferenceName = '#filtered-audience';
    }
  }

  setClassDateRange() {
    if (
      this._dateRangeFilterRef.datePicker &&
      this._dateRangeFilterRef.datePicker.container &&
      this._dateRangeFilterRef.datePicker.container.length &&
      this._dateRangeFilterRef.datePicker.container[0].classList
    ) {
      this._dateRangeFilterRef.datePicker.container[0].classList.value = `${this._dateRangeFilterRef.datePicker.container[0].classList.value} advance-feasibility-calender`;
    }
  }

  showCheckBoxAlert(event: Event) {
    if (this.isDisabledExclusionCheckBox) {
      event.preventDefault();
      this._toasterService.warning(
        notifyMessage.warningMessage.EXCLUSION.REMOVE_EXCLUSION_ALERT
      );
      return;
    }
  }

  get ProjectManagerLabel(): string {
    if (this._auth.isLoggedInAsServiceBuyer()) {
      return 'Buyer Project manager';
    }

    if (this._auth.userType === 'buyer') {
      return 'Project Manager';
    }

    return '';
  }

  get isShowExclusionCheckbox() {
    return (
      this.selectFeasibilityType.name !==
        Constants.ADVANCE_FEASIBILITY.FEASIBILITY_TYPE.INCLUDE &&
      !!this._auth.buyerConfig?.includeToo
    );
  }

  private _onChangeLanguageCountryResetFilter(
    locale: LocaleLanguageCountry,
    data: Locale
  ) {
    if (
      locale.languageCode &&
      locale.countryCode &&
      (this._locale.languageCode != data.language_code ||
        this._locale.countryCode != data.country_code)
    ) {
      this.resetFilteredAudience();
    }
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }
}
